export enum BlockViewType {
  Bypass = 'bypass',
  Display = 'display',
  Hidden = 'hidden',
}
